import React from 'react';

const PopularBets = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 4.16667H5.83333C5.39131 4.16667 4.96738 4.34226 4.65482 4.65482C4.34226 4.96738 4.16667 5.39131 4.16667 5.83333V15.8333C4.16667 16.2754 4.34226 16.6993 4.65482 17.0118C4.96738 17.3244 5.39131 17.5 5.83333 17.5H14.1667C14.6087 17.5 15.0326 17.3244 15.3452 17.0118C15.6577 16.6993 15.8333 16.2754 15.8333 15.8333V5.83333C15.8333 5.39131 15.6577 4.96738 15.3452 4.65482C15.0326 4.34226 14.6087 4.16667 14.1667 4.16667H12.5M7.5 4.16667C7.5 3.72464 7.6756 3.30072 7.98816 2.98816C8.30072 2.67559 8.72464 2.5 9.16667 2.5H10.8333C11.2754 2.5 11.6993 2.67559 12.0118 2.98816C12.3244 3.30072 12.5 3.72464 12.5 4.16667M7.5 4.16667C7.5 4.60869 7.6756 5.03262 7.98816 5.34518C8.30072 5.65774 8.72464 5.83333 9.16667 5.83333H10.8333C11.2754 5.83333 11.6993 5.65774 12.0118 5.34518C12.3244 5.03262 12.5 4.60869 12.5 4.16667M11.6667 9.16667H9.58333C9.25181 9.16667 8.93387 9.29836 8.69945 9.53278C8.46503 9.7672 8.33333 10.0851 8.33333 10.4167C8.33333 10.7482 8.46503 11.0661 8.69945 11.3006C8.93387 11.535 9.25181 11.6667 9.58333 11.6667H10.4167C10.7482 11.6667 11.0661 11.7984 11.3006 12.0328C11.535 12.2672 11.6667 12.5851 11.6667 12.9167C11.6667 13.2482 11.535 13.5661 11.3006 13.8005C11.0661 14.035 10.7482 14.1667 10.4167 14.1667H8.33333M10 14.1667V15M10 8.33333V9.16667",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { PopularBets };
//# sourceMappingURL=PopularBets.js.map
